import React from "react";
import { useNavigate } from "react-router-dom";

import PageTitle from "../../layouts/PageTitle";
import { useGetNetplusTransfersQuery } from "../../../store/appApi";
import { formatCurrency, formatDateLabel } from "./netplusConfig";

const panelClass =
  "rounded-3xl border border-gray-200 bg-white shadow-xl shadow-slate-200/70";

const NetplusTransfersList = () => {
  const navigate = useNavigate();
  const { data, isLoading, isFetching } = useGetNetplusTransfersQuery();

  const transfers = Array.isArray(data?.transfers) ? data.transfers : [];
  const loading = isLoading || isFetching;

  return (
    <>
      <PageTitle activeMenu="Transfer History" motherMenu="Netplus Receipts" />

      <div className="space-y-6">
        <section className={`${panelClass} p-6`}>
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div>
              <div className="inline-flex rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-amber-700">
                Netplus Receipts
              </div>
              <h1 className="mt-4 text-3xl font-semibold text-gray-900">
                Transfer History
              </h1>
              <p className="mt-2 text-sm text-gray-500">
                Every amount moved out of Netplus — either into the project
                Daybook, or straight into an employee's own imprest.
              </p>
            </div>
            <button
              type="button"
              className="rounded-full border-2 border-amber-500 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-gray-700"
              onClick={() => navigate("/netplus")}
            >
              Back to Receipts
            </button>
          </div>
        </section>

        <section className={panelClass}>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 text-sm">
              <thead className="bg-gray-50 text-gray-500">
                <tr>
                  <th className="px-5 py-2.5 text-left font-medium">Date</th>
                  <th className="px-5 py-2.5 text-right font-medium">Amount</th>
                  <th className="px-5 py-2.5 text-right font-medium">
                    Netplus Balance After
                  </th>
                  <th className="px-5 py-2.5 text-left font-medium">Destination</th>
                  <th className="px-5 py-2.5 text-left font-medium">Remarks</th>
                  <th className="px-5 py-2.5 text-left font-medium">Transferred By</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {loading && (
                  <tr>
                    <td colSpan={6} className="px-5 py-10 text-center text-gray-500">
                      Loading transfers...
                    </td>
                  </tr>
                )}

                {!loading && transfers.length === 0 && (
                  <tr>
                    <td colSpan={6} className="px-5 py-10 text-center text-gray-500">
                      No transfers recorded yet.
                    </td>
                  </tr>
                )}

                {!loading &&
                  transfers.map((transfer) => (
                    <tr key={transfer._id}>
                      <td className="px-5 py-2.5 text-gray-600">
                        {formatDateLabel(transfer.created)}
                      </td>
                      <td className="px-5 py-2.5 text-right text-gray-900">
                        {formatCurrency(transfer.amount)}
                      </td>
                      <td className="px-5 py-2.5 text-right text-gray-600">
                        {formatCurrency(transfer.balance)}
                      </td>
                      <td className="px-5 py-2.5 text-gray-600">
                        {transfer.imprestEmployeeId?.name
                          ? `Employee — ${transfer.imprestEmployeeId.name}`
                          : "Daybook"}
                      </td>
                      <td className="px-5 py-2.5 text-gray-600">
                        {transfer.remarks || "—"}
                      </td>
                      <td className="px-5 py-2.5 text-gray-600">
                        {transfer.transferredBy?.name || "—"}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </>
  );
};

export default NetplusTransfersList;
